import React, { Component, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 

import { faCaretDown, faClock, faTimes } from '@fortawesome/fontawesome-free-solid'

export default class Navigation extends Component {
   
    render() {
        const englishSelected = this.props.englishSelected
        const englishLanguage = this.props.englishLanguage
        const frenchLanguage = this.props.frenchLanguage
        const homeLink = this.props.homeLink
        const doctorsLink = this.props.doctorsLink
        const contactLink = this.props.contactLink
        const languageLink = this.props.languageLink
        const homeSelected= this.props.homeSelected
        const doctorsSelected= this.props.doctorsSelected
        const contactSelected= this.props.contactSelected
        const displayMenu = this.props.displayMenu
        const handleMenu = this.props.handleMenu
        
       
        return (
            <Fragment>
                <header id="header">
                    <div className="container">
                        <div id="main-logo">
                            <p onClick={homeLink}>
                                Centre Médical
                            <br/>
                                Bonnevoie
                            </p>
                        </div>
                        <nav className={displayMenu ? 'active' : 'nope' }>
                            <div className="close-button" onClick={handleMenu}>
                                Fermer le menu
                                <FontAwesomeIcon className="fa"  size="3x" icon={faTimes} /> 
                            </div>
                            <ul>
                                <li className={homeSelected ? 'active item' : 'item'} >
                                <div onClick={homeLink}>
                                    {englishSelected ? englishLanguage.titleHome : frenchLanguage.titleHome }
                                    </div>
                                </li>
                                <li className={doctorsSelected ? 'active item' : 'item'}>
                                    <div onClick={doctorsLink}>
                                        {englishSelected ? englishLanguage.titleDoctor : frenchLanguage.titleDoctor }
                                    </div>
                                </li>
                                <li className={contactSelected ? 'active item' : 'item'} >
                                    <div onClick={contactLink}>
                                    Contact
                                    </div>
                                </li>
                                <li className="item" onClick={languageLink}>
                                    <div>
                                    {englishSelected ? 'en' : 'fr' }
                                    <FontAwesomeIcon className="fa"  size="1x" icon={faCaretDown} />
                                    </div>
                                </li>
                            </ul>
                        </nav>
                        <div className="item burger" onClick={handleMenu}>
                            <div id="nav-icon" >
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </header>
                <header id="sub-header">
                    <div className="container">
                        <p className="schedule" style={{height :'3rem'}}>
                            {/*<FontAwesomeIcon className="fa"  size="1x" icon={faClock} />*/}
                            {/*{englishSelected ? ' ' + englishLanguage.scheduleNav : ' ' + frenchLanguage.scheduleNav }
                            : 8h00 - 12h00 / 14h00 - 18h00*/}
                        </p>
                        
                    </div>
                </header>
            </Fragment>
            
        
        )
    }
}
